import { NumericalOperator, StringOperator } from "../models/SegmentDefinitions.js";
const segmentDefinitionGenerator = (segDefinition) => {
  if (segDefinition.customColumnSegment) {
    return segDefinition.customColumnSegment;
  } else if (segDefinition.segmentValues) {
    return buildTernaryExpression(segDefinition.segmentValues);
  }
  return "";
};
const buildTernaryExpression = (segValues) => {
  let resultString = "";
  for (let segValueName in segValues) {
    let groupedConditions = segValues[segValueName];
    let conditionsString = buildOrGroupConditions(groupedConditions);
    if (conditionsString == "") {
      resultString = resultString + `${segValueName}`;
    } else {
      resultString = resultString + `${conditionsString} ? ${segValueName} : `;
    }
  }
  return resultString;
};
const buildOrGroupConditions = (orGroupConditions) => {
  let resultString = "";
  for (let i = 0; i < orGroupConditions.length; i++) {
    if (i > 0) {
      resultString = resultString + " || ";
    }
    const andGroupConditions = orGroupConditions[i];
    const andString = buildAndGroupConditions(andGroupConditions);
    resultString = resultString + andString;
  }
  return resultString;
};
const buildAndGroupConditions = (andGroupConditions) => {
  let resultString = "";
  andGroupConditions.forEach((condition) => {
    if (resultString != "") {
      resultString = resultString + " && ";
    }
    resultString = resultString + buildCondition(condition);
  });
  if (andGroupConditions.length > 1) {
    return addParentheses([resultString]);
  }
  return resultString;
};
const buildCondition = (condition) => {
  if (Object.values(NumericalOperator).includes(condition.operator)) {
    return `${condition.column} ${condition.operator} ${condition.value}`;
  }
  if (Object.values(StringOperator).includes(condition.operator)) {
    return `${condition.column}.${condition.operator}(${condition.value})`;
  }
  return "";
};
const addParentheses = (entities) => {
  return "(" + entities.join(", ") + ")";
};
export {
  addParentheses,
  buildAndGroupConditions,
  buildCondition,
  buildOrGroupConditions,
  buildTernaryExpression,
  segmentDefinitionGenerator
};
//# sourceMappingURL=SegmentDefinitionGenerator.js.map
